import React from 'react';


function DeclarationEnforcementAndStatus() {
  return (
    <>

      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 pb-4 border-b border-gray-200">Declaration Enforcement and Status</h1>

        <div className="space-y-12">
          
          <section>
            <h2 className="text-2xl font-bold text-[#102A43] mb-6">Enforcement and Conditional Status</h2>
            <p className="text-[#64748B] leading-relaxed mb-6">
              AASC Accountability Declaration is not a lifetime award. It is a conditional status that is actively monitored. The Council reserves the right to suspend or withdraw declaration at any time to protect the integrity of the standard.
            </p>
            
            <div className="bg-red-50 border border-red-100 p-6 rounded-sm mb-8">
              <h3 className="text-lg font-bold text-red-900 mb-4">Suspension and Withdrawal Triggers</h3>
              <ul className="list-disc pl-5 space-y-2 text-red-800">
                <li><strong>Misrepresentation:</strong> Making false claims about the scope or meaning of declaration.</li>
                <li><strong>Failure to Maintain Controls:</strong> Evidence that the agency has ceased using the required protocols.</li>
                <li><strong>Failure to Provide Disclosures:</strong> Not providing the required liability and scope disclosures to clients.</li>
                <li><strong>Material Changes Without Notification:</strong> Significant changes to agency structure or tech stack without updating the Council.</li>
                <li><strong>Breach of Standards:</strong> Verified reports of operations violating the fundamental Human-in-the-Loop or Accountability standards.</li>
                <li><strong>Misuse of Marks:</strong> Using the declaration seal on non-declared products or services.</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4">Complaint Process</h2>
            <p className="text-[#64748B] mb-4">
              Formal complaints from clients or the public may trigger a review. During an investigation, an agency's status may be changed to "Under Review" or "Suspended" in the public registry.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4">Registry Status Meanings</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="border p-4 rounded bg-green-50">
                <span className="font-bold text-green-900">Active</span>
                <p className="text-sm text-green-800">Fully compliant and valid.</p>
              </div>
              <div className="border p-4 rounded bg-yellow-50">
                <span className="font-bold text-yellow-900">Suspended</span>
                <p className="text-sm text-yellow-800">Temporarily invalid pending review or admin action.</p>
              </div>
              <div className="border p-4 rounded bg-[#F9FAFB]">
                <span className="font-bold text-[#102A43]">Expired</span>
                <p className="text-sm text-gray-800">Term ended without renewal.</p>
              </div>
              <div className="border p-4 rounded bg-red-50">
                <span className="font-bold text-red-900">Withdrawn</span>
                <p className="text-sm text-red-800">Revoked for cause or by request.</p>
              </div>
            </div>
          </section>

          <section className="bg-gray-100 p-6 rounded text-sm text-gray-600">
            <h3 className="font-bold text-[#102A43] mb-2">Scope of Authority</h3>
            <p>
              The AASC does not regulate business operations or enforce laws. Our enforcement power is strictly limited to the status of the declaration and the accuracy of the registry. We cannot issue fines, shut down businesses, or adjudicate legal disputes.
            </p>
          </section>

        </div>
      </div>
    </>
  );
}

export default DeclarationEnforcementAndStatus;